import {createContext} from 'react';

export const DemoModeContext = createContext({});
